import { render, staticRenderFns } from "./big-map-dialog.vue?vue&type=template&id=0b1f7fda&scoped=true"
import script from "./big-map-dialog.vue?vue&type=script&lang=js"
export * from "./big-map-dialog.vue?vue&type=script&lang=js"
import style0 from "./big-map-dialog.vue?vue&type=style&index=0&id=0b1f7fda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1f7fda",
  null
  
)

export default component.exports